import MoveTo from 'moveto';

export default new class Smooth {

    private mv: MoveTo = new MoveTo();

    scrollToDiv(element: HTMLElement): void {
        return this.mv.move(element);
    }

}
